export const gdpr = {
  routes: [
    {
      // TKP-89: ekran kalktı; eski adres modülün açılış sayfasına (Varlıklar) yönlenir. Backend yol haritası verisi yerinde.
      path: "/gdpr/roadmap",
      redirect: "/gdpr/entities",
    },
  ],
};

export const kvkk = {
  routes: [
    {
      // TKP-89: ekran kalktı; eski adres modülün açılış sayfasına (Varlıklar) yönlenir. Backend yol haritası verisi yerinde.
      path: "/kvkk/roadmap",
      redirect: "/kvkk/entities",
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/roadmap",
      component: () => import("../organization-ddo-roadmap-view"),
    },
  ],
};

export const bgys = {
  routes: [
    {
      path: "/bgys/roadmap",
      component: () => import("../organization-bgys-roadmap-view"),
    },
  ],
};

export const organization = {
  routes: [
    {
      // TKP-146 / tasarım s.35 md.2: organizasyon paneli yol haritası kalktı; eski adres panele yönlenir. Backend yol haritası
      // verisi, aşamalara bağlı görev üretimi ve store yerinde (görevlerdeki "aşamaya git" bağlantısı panele gider).
      path: "/organization/roadmap",
      redirect: "/organization",
    },
  ],
};

export const management = {
  // TKP-139: yönetici paneli yol haritası ekranları kalktı (tasarım s.28 md.2); eski adresler panele yönlenir, backend verisi yerinde
  routes: ["platform", "gdpr", "kvkk", "bgys", "ddo"].map((product) => ({ path: `/management/roadmap/${product}`, redirect: "/management/account-workspace-organization" })),
};
